import ApiBase from '@/api/base';

export default {
  getClientLimitSetting() {
    return ApiBase.get(`/user/client_limit_setting`);
  },
};
